import * as Yup from 'yup';

export const municipalityFormSchema = Yup.object().shape({
  muncipalityName: Yup.string().required('Municipality name is required'),
  municipalityCode: Yup.string().required('Municipality code is required'),
  status: Yup.string().required('Status is required'),
  stateID: Yup.string().required('State is required'),
  contactEmail: Yup.string().email('Invalid email').required('Contact email is required'),
});
